export {
  InjectionMode,
  Stylesheet,
  concatStyleSets,
  concatStyleSetsWithProps,
  fontFace,
  keyframes,
  mergeStyleSets,
  mergeStyles,
} from '@fluentui/merge-styles';
export type {
  IFontFace,
  IFontWeight,
  IRawStyle,
  IStyle,
  IStyleSet,
  IProcessedStyleSet,
  IStyleSheetConfig,
  ICSPSettings,
} from '@fluentui/merge-styles';
